var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEstability(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_65_165)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    rx: 13.2215,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8938 34.415L22.2188 34.0576V32.2949L16.8953 21.0566H14.4172L9.09375 32.2949V34.1435L9.38318 34.4576C10.1781 35.3184 11.1424 36.0055 12.2156 36.4758C13.2887 36.9462 14.4475 37.1896 15.6192 37.1908H15.6479C16.8244 37.1855 17.987 36.9361 19.0622 36.4583C20.1373 35.9805 21.1015 35.2848 21.8938 34.415ZM20.0312 33.1978C18.8642 34.3569 17.2853 35.0062 15.6405 35.0034H15.6179C14.002 35.0115 12.4465 34.3898 11.2812 33.2702V32.7871L15.6562 23.5509L20.0312 32.7871V33.1978Z",
    fill: "#2A4887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5828 21.0566H34.1047L28.7812 32.2949V34.1435L29.0707 34.4576C29.8656 35.3184 30.8299 36.0055 31.9031 36.4758C32.9762 36.9462 34.135 37.1896 35.3067 37.1908H35.3354C36.5119 37.1855 37.6745 36.9361 38.7497 36.4583C39.8248 35.9805 40.789 35.2846 41.5813 34.4149L41.9062 34.0576V32.2949L36.5828 21.0566ZM39.7188 33.1978C38.5517 34.3569 36.9728 35.0062 35.328 35.0034H35.3054C33.6895 35.0115 32.134 34.3898 30.9688 33.2702V32.7871L35.3438 23.5509L39.7188 32.7871V33.1978Z",
    fill: "#2A4887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5938 21.4435C27.2022 21.2606 27.7558 20.9297 28.2051 20.4805C28.6543 20.0312 28.9852 19.4776 29.1681 18.8692H36.4375V16.6817H29.1681C28.9327 15.8917 28.4485 15.1988 27.7876 14.7061C27.1267 14.2134 26.3243 13.9473 25.5 13.9473C24.6757 13.9473 23.8733 14.2134 23.2124 14.7061C22.5515 15.1988 22.0673 15.8917 21.8319 16.6817H14.5625V18.8692H21.8319C22.0148 19.4776 22.3457 20.0312 22.7949 20.4805C23.2442 20.9297 23.7978 21.2606 24.4062 21.4435V39.6504H17.2969V41.8379H33.7031V39.6504H26.5938V21.4435ZM23.8594 17.7754C23.8594 17.4509 23.9556 17.1337 24.1359 16.8639C24.3161 16.5941 24.5724 16.3838 24.8722 16.2597C25.1719 16.1355 25.5018 16.103 25.8201 16.1663C26.1383 16.2296 26.4307 16.3859 26.6601 16.6153C26.8895 16.8448 27.0458 17.1371 27.1091 17.4553C27.1724 17.7736 27.1399 18.1035 27.0157 18.4032C26.8916 18.703 26.6813 18.9593 26.4115 19.1395C26.1417 19.3198 25.8245 19.416 25.5 19.416C25.0649 19.416 24.6476 19.2432 24.3399 18.9355C24.0322 18.6278 23.8594 18.2105 23.8594 17.7754Z",
    fill: "#2A4887"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_65_165",
    x: -16.7473,
    y: -16.7473,
    width: 84.4945,
    height: 84.4945,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8.37364
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_65_165"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_65_165",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstability);
export default __webpack_public_path__ + "static/media/estability.cfb5200efeaec8ab5634c360e06a2c1c.svg";
export { ForwardRef as ReactComponent };